import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../base-service/base-api.service';
import { SecurityTransactionMenuItem } from '../../models/security-transaction-menu-item/security-transaction-menu-item.model';

@Injectable()
export class MenuItemsService extends BaseApiService {

    private sendCountToChild = new Subject<SecurityTransactionMenuItem[]>();

    data$ = this.sendCountToChild.asObservable();

    getMenuItems(): Observable<SecurityTransactionMenuItem[]> {
        return this.get('Foundation/User/MenuItems')
            .pipe(map(response => response.result));
    }

    sendData(result: SecurityTransactionMenuItem[]) {
        this.sendCountToChild.next(result);
    }
}
